(function (factory) {
    typeof define === 'function' && define.amd ? define(['kendo.core'], factory) :
    factory();
})((function () {
    (function( window, undefined$1 ) {
        kendo.cultures["es-CO"] = {
            name: "es-CO",
            numberFormat: {
                pattern: ["-n"],
                decimals: 2,
                ",": ".",
                ".": ",",
                groupSize: [3],
                percent: {
                    pattern: ["-n %","n %"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "%"
                },
                currency: {
                    name: "Colombian Peso",
                    abbr: "COP",
                    pattern: ["-$ n","$ n"],
                    decimals: 2,
                    ",": ".",
                    ".": ",",
                    groupSize: [3],
                    symbol: "$"
                }
            },
            calendars: {
                standard: {
                    days: {
                        names: ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
                        namesAbbr: ["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],
                        namesShort: ["DO","LU","MA","MI","JU","VI","SA"]
                    },
                    months: {
                        names: ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
                        namesAbbr: ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."]
                    },
                    AM: ["a. m.","a. m.","A. M."],
                    PM: ["p. m.","p. m.","P. M."],
                    patterns: {
                        d: "d/MM/yyyy",
                        D: "dddd, d 'de' MMMM 'de' yyyy",
                        F: "dddd, d 'de' MMMM 'de' yyyy h:mm:ss tt",
                        g: "d/MM/yyyy h:mm tt",
                        G: "d/MM/yyyy h:mm:ss tt",
                        m: "d 'de' MMMM",
                        M: "d 'de' MMMM",
                        s: "yyyy'-'MM'-'dd'T'HH':'mm':'ss",
                        t: "h:mm tt",
                        T: "h:mm:ss tt",
                        u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                        y: "MMMM 'de' yyyy",
                        Y: "MMMM 'de' yyyy"
                    },
                    "/": "/",
                    ":": ":",
                    firstDay: 0
                }
            }
        };
    })();

}));
